import React from 'react';
import styled from 'styled-components';
import ProcessingStatus from './ProcessingStatus';

const JSONContainer = styled.div`
  width: 50%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  background: #f5f5f5;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Reference = styled.sup`
  color: blue;
  cursor: pointer;
  position: relative;
  
  &:hover::after {
    content: attr(data-coords);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
  }

  &:hover {
    text-decoration: underline;
  }
`;

// Function to format display keys
const formatDisplayKey = (key) => {
  // Handle special cases
  if (key === "Umbrella_Name") return "Umbrella Name";
  if (key === "Redemption_Fee") return "Redemption Fee";
  
  // For other keys, capitalize first letter of each word
  return key.split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const JSONViewer = ({ data, onReferenceClick, isProcessing, wsStatus, progress, extractionProgress }) => {
  const renderValue = (value, coordinates, pageNumber, label) => {
    if (!value) return "";
    
    return (
      <span>
        {value}
        {coordinates && coordinates.length === 4 && (
          <Reference 
            onClick={() => onReferenceClick(coordinates, pageNumber - 1, label)}
            data-coords={`[${coordinates.map(coord => Math.round(coord)).join(', ')}]`}
          >
            {pageNumber} | [{coordinates.map(coord => Math.round(coord)).join(', ')}]
          </Reference>
        )}
      </span>
    );
  };

  const renderJSON = (obj) => {
    if (!obj) return null;

    return Object.entries(obj).map(([key, value]) => {
      const displayKey = formatDisplayKey(key);
      
      if (typeof value === 'object' && value !== null) {
        if (Array.isArray(value)) {
          // Handle arrays (subfunds and shares)
          return (
            <div key={key} style={{ marginBottom: '15px' }}>
              <strong>{displayKey}:</strong>
              <div style={{ marginLeft: 20 }}>
                {value.filter(item => 
                  Object.values(item).some(v => v?.value)
                ).map((item, index) => (
                  <div key={index} style={{ marginBottom: '10px' }}>
                    {Object.entries(item).map(([subKey, subValue]) => (
                      subValue?.value && (
                        <div key={subKey}>
                          <strong>{formatDisplayKey(subKey)}:</strong>{' '}
                          {renderValue(
                            subValue.value, 
                            subValue.coordinates,
                            subValue.page_number,
                            `${key}.${index}.${subKey}`
                          )}
                        </div>
                      )
                    ))}
                  </div>
                ))}
              </div>
            </div>
          );
        } else if ('value' in value) {
          // Handle direct values with coordinates
          return (
            <div key={key} style={{ marginBottom: '10px' }}>
              <strong>{displayKey}:</strong>{' '}
              {renderValue(
                value.value, 
                value.coordinates,
                value.page_number,
                key
              )}
            </div>
          );
        }
      }
      return null;
    });
  };

  return (
    <JSONContainer>
      {isProcessing && wsStatus && (
        <ProcessingStatus 
          status={wsStatus}
          progress={progress}
          extractionProgress={extractionProgress}
        />
      )}
      {renderJSON(data)}
    </JSONContainer>
  );
};

export default JSONViewer; 